import { render, staticRenderFns } from "./TruckReportTemplate.vue?vue&type=template&id=590fa92f&scoped=true"
import script from "./TruckReportTemplate.vue?vue&type=script&lang=js"
export * from "./TruckReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./TruckReportTemplate.vue?vue&type=style&index=0&id=590fa92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fa92f",
  null
  
)

export default component.exports